/* eslint-disable react/function-component-definition */
import Routes from 'Routes';
import { Provider } from 'react-redux';
import 'sass/index.scss';
import configureStore from 'Store/configureStore';

const App = () => {
  const store = configureStore();
  return (
    <Provider store={store}>
      <Routes />
    </Provider>
  );
};

export default App;
